var _circle, _path, _mask, _rect, _path2, _mask2, _rect2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhysical(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16,
    fill: "#F2D9F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 15a.5.5 0 0 1 .5-.5H8v3H6.5A.5.5 0 0 1 6 17v-2Z",
    fill: "#963695",
    stroke: "#963695"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1,
    stroke: "#963695",
    strokeWidth: 4,
    mask: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#963695",
    stroke: "#963695",
    d: "M14 14.5h5v3h-5z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 9,
    width: 7,
    height: 14,
    rx: 1,
    stroke: "#963695",
    strokeWidth: 4,
    mask: "url(#b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 14.5h1.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H25v-3Z",
    fill: "#963695",
    stroke: "#963695"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhysical);
export default __webpack_public_path__ + "static/media/physical.5d3e6abf0866ef426170fdd2538bf6e7.svg";
export { ForwardRef as ReactComponent };